import React from 'react';

export default class PrintButton extends React.Component {
	constructor(props) {
		super(props);
		this.buttonClicked = this.buttonClicked.bind(this);
	}
	componentDidMount() {
		
	  }
	buttonClicked () {
		window.print();
	}
	  render() {
		    return (
		    		<button onClick={this.buttonClicked} className='btn btn-success mid-button hidden-print' disabled={this.props.enabled === true ? '' : 'disabled' }><span className="glyphicon glyphicon-print" aria-hidden="true"></span> Drucken</button>
		    );
		  }
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/print_button.js